import { Helmet } from 'react-helmet-async';

export interface MetaProps {
  title: string;
  brand?: string;
}

export const Meta: React.FC<MetaProps> = (props) => {
  const { title, brand } = props;

  const fullTitle = title
    ? `${title} - ${brand || 'Exercise.com'}`
    : `${brand || 'Exercise.com'}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};
